import { sectionRenderer } from '@theme/section-renderer';

/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 5;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (_) { }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch (_) { }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }
}

export class RecentlyViewedProducts extends HTMLElement {
  async connectedCallback() {
    const { sectionId, productId, rendered } = this.dataset;
    if (!sectionId || rendered === 'true') return;

    let viewedProducts = RecentlyViewed.getProducts();
    if (productId) {
      viewedProducts = viewedProducts.filter((id) => id !== productId);
    }
    viewedProducts = viewedProducts.slice(0, 4);

    if (viewedProducts.length === 0) {
      this.hidden = true;
      return;
    }

    const searchUrl = this.dataset.searchUrl || (typeof Theme !== 'undefined' && Theme?.routes?.search_url) || '/search';
    const url = new URL(searchUrl, location.origin);
    url.searchParams.set('q', viewedProducts.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      this.dataset.rendered = 'true';
      await sectionRenderer.renderSection(sectionId, { cache: false, url });
    } catch (error) {
      console.error('Error loading recently viewed products:', error);
      this.hidden = true;
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
